import { render, staticRenderFns } from "./SlotAccordion.vue?vue&type=template&id=5804b931&scoped=true"
import script from "./SlotAccordion.vue?vue&type=script&lang=js"
export * from "./SlotAccordion.vue?vue&type=script&lang=js"
import style0 from "./SlotAccordion.vue?vue&type=style&index=0&id=5804b931&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5804b931",
  null
  
)

export default component.exports